import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Image, Grid, Modal, Divider } from 'semantic-ui-react';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';
import CampaignForm from '../campaign-form';
import HelpLink from '../help-link';
import ThemeSelector from '../../themes/theme-selector';

const noPadding = {
  padding: '0',
};

const imageStyle = {
  display: 'block',
  margin: '170px auto 0px auto',
};

const leftBlockStyle = {
  ...noPadding,
  backgroundColor: '#f7fafa',
  borderRadius: '4px',
};

const rightBlockStyle = {
  padding: '50px',
};

const linkWrapperStyle = {
  width: '100%',
  textAlign: 'center',
  marginTop: 40,
};

const AddCampaignModal = props => {
  const {
    title,
    buttonLabel,
    onClose,
    addCampaignFormProps,
    onAddCampaignSubmit,
  } = props;
  const { disableHelpLinks } = ThemeSelector.theme();

  return (
    <Modal
      open
      onClose={onClose}
    >
      <Modal.Content style={noPadding}>
        <Grid>
          <Grid.Row style={noPadding}>
            <Grid.Column width={8} style={leftBlockStyle}>
              <Image src="/images/add-campaign.svg" style={imageStyle} />
              {
                !disableHelpLinks &&
                    (
                      <div style={linkWrapperStyle}>
                        <HelpLink url="https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign" />
                      </div>
                    )
              }
            </Grid.Column>
            <Grid.Column width={8} style={rightBlockStyle}>
              <h3>{title}</h3>
              <Divider hidden />
              <CampaignForm
                {...addCampaignFormProps}
              />
              <Divider hidden />
              <DyzioPrimaryButton
                onClick={onAddCampaignSubmit}
                fluid
                label={buttonLabel}
                hasIcon
                icon={<Icon name="save" />}
                floated={false}
              />
              <Divider hidden />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

AddCampaignModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAddCampaignSubmit: PropTypes.func.isRequired,
  addCampaignFormProps: PropTypes.object.isRequired,
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
};

AddCampaignModal.defaultProps = {
  title: 'Add a campaign',
  buttonLabel: 'Save',
};

export default AddCampaignModal;



/** WEBPACK FOOTER **
 ** ./src/components/add-campaign-modal/index.js
 **/